<template>
    <!-- 用户列表 -->
    <vAdminListComponent :postList="postList" v-if="flag"></vAdminListComponent>
</template>
<script>
import vAdminListComponent from '../../listComponent/jurisdiction/adminListComponent.vue';
export default {
    name: 'adminList',
    components: {
        vAdminListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                name: true,
                code: true,
                mobile: true,
                status: true,
                role_id: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                // downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },

    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>